import type { Locale } from '@enmon/commons';
import { SharedLanguageProvider } from '@enmon-monorepo/i18n/react';
import { type ReactNode, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { getInventoryMessages, registerInventoryIntl } from './i18n';

interface LanguageProviderProps {
  children: ReactNode;
  locale: Locale;
}

export function LanguageProvider({ children, locale }: LanguageProviderProps) {
  useEffect(() => {
    document.documentElement.lang = locale;
  }, [locale]);

  return (
    <SharedLanguageProvider locale={locale} messages={getInventoryMessages(locale)}>
      <IntlRegistrar>{children}</IntlRegistrar>
    </SharedLanguageProvider>
  );
}

/**
 * Registers the active `IntlShape` so the imperative `translateInventoryText`
 * helpers translate against the current locale. Re-registers on locale change.
 */
function IntlRegistrar({ children }: { children: ReactNode }) {
  const intl = useIntl();
  registerInventoryIntl(intl);

  return <>{children}</>;
}
